import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendJob, BackendMutationExtractResourceArgs } from 'src/types/backend';

const MUTATION = gql`
  mutation ExtractResource(
    $customerId: ID!
    $workspaceId: ID!
    $input: PerformanceCenterCustomerResourceInputType!
  ) {
    extractResource(customerId: $customerId, workspaceId: $workspaceId, input: $input) {
      id
      status
    }
  }
`;

type Variables = BackendMutationExtractResourceArgs;
type Result = Pick<BackendJob, 'id' | 'status'>;

export const extractResource = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(result.data);
};
